export default "__VITE_ASSET__BGBQbyVv__"